import React from "react";
import "../../styles/Contact/conatct.css"; // Ensure this path matches

const ContactHero = () => {
  return (
    <section className="contact-hero-section">
      {/* 1. Dark Overlay for readability */}
      <div className="contact-hero-overlay"></div>

      {/* 2. Content Container */}
      <div className="container contact-hero-content">
        <div className="row h-100 align-items-center">
          <div className="col-12 col-md-10 col-lg-8">
            
            {/* Breadcrumb */}
            <div className="contact-breadcrumb mb-3">
              <span>Home</span>
              <span className="separator">|</span>
              <span className="current">Contact</span>
            </div>

            {/* Main Headline */}
            <h1 className="contact-hero-title">
              How May we Help You?
            </h1>

          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;